const splitArrayIntoChunks = <T>(array: T[], chunkSize: number = 4, collapse: boolean = false): (T | null)[][] => {
  const result: (T | null)[][] = [];

  for (let i = 0; i < Math.ceil(array.length / chunkSize); i++) {
    const chunk: (T | null)[] = array.slice(i * chunkSize, (i + 1) * chunkSize);

    if (!collapse || array.length > chunkSize) {
      while (chunk.length < chunkSize) {
        chunk.push(null);
      }
    }

    result.push(chunk);
  }

  return result;
};

export default splitArrayIntoChunks;
